/**
 * Created by msudalaiyandi on 2/8/16.
 */

'use strict';

var values = require('lodash.values'),
    get = require('lodash.get');

var Mixin = {

    getErrors: function getErrors(field) {
        var errors = this.props.errors,
            found = this.findInObject(errors, field);

        return found && (typeof found === 'object' && values(found) || typeof found === 'string' && [found]);
    },

    hasErrors: function hasErrors() {
        if (!this.props.errors) {
            return false;
        }
        var errors = Object.keys(this.props.errors);
        return errors && errors.length > 0;
    },

    findInObject: function findInObject(obj, path, delimiter) {
        if (!obj || !path) {
            return obj;
        }
        if (delimiter && typeof path === 'string') {
            path = path.split(delimiter);
        }
        return get(obj, path);
    },

    i18n: function i18n(dictionary, key) {
        if (!dictionary || !key) {
            return '';
        }
        var content = this.findInObject(dictionary, key);
        return content || key;
    },

    cloneObject: function cloneObject(parent) {
        var newObject = {};
        if (!parent) {
            return parent;
        }
        if (Array.isArray(parent)) {
            newObject = [];
            parent.forEach((function (value) {
                if (typeof value === 'object') {
                    value = this.cloneObject(value);
                }
                newObject.push(value);
            }).bind(this));
        } else if (typeof parent === 'object') {
            Object.keys(parent).forEach((function (key) {
                if (typeof parent[key] === 'object') {
                    newObject[key] = this.cloneObject(parent[key]);
                } else {
                    newObject[key] = parent[key];
                }
            }).bind(this));
        } else {
            newObject = parent;
        }
        return newObject;
    }
};

module.exports = Mixin;